
var Modal = require('ffss/ui/Modal');

class Confirm extends Modal {

    defaultOptions(){
        var options = {
            //modal options
            'modalClass': 'confirm-modal',
            'verticalCentered': true,
            'modalSize': 'medium',
            'showFooter': false,
            'showHeader': false,

            //confirmModal options
            'contentClass': 'modal-confirm-content',
            'messageClass': 'modal-confirm-message',
            'messageContent': '',
            'btnConfirmContent': 'OK',
            'btnConfirmClass': 'btn btn-primary btn-confirm',
            'btnCancelContent': 'Annuler',
            'btnCancelClass': 'btn btn-secondary btn-cancel',
            'showBtnCancel': true,

            //callbacks
            beforeConfirm: function(){return;},
            onConfirm: function(event,modal){return;},
            onCancel: function(event,modal){return;},
        };
        return Object.assign(super.defaultOptions(),options);
    }

    constructor(options){
        super(options);
        //this.settings = $.extend(this.defaultOptions(),options);//done by super class

        // initialize attributes
        //this.$example = $('.class',this.$container);

        // bind events methods
        //this.onEvent = this.onEvent.bind(this);
        this.beforeConfirm = this.beforeConfirm.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onCancel = this.onCancel.bind(this);

        this.setBodyContent(this.buildContent());

    }

    buildMessage(){
        let $message = $('<div/>')
        .addClass(this.settings.messageClass)
        .append(this.settings.messageContent);

        return $message;
    }

    buildContent(){
        var self = this;

        var $content = $('<div/>')
        .addClass(this.settings.contentClass);

        this.$message = this.buildMessage();

        this.$btnConfirm = $('<button/>')
        .addClass(this.settings.btnConfirmClass)
        .append(this.settings.btnConfirmContent)
        .on('click',this.onConfirm);

        if(this.settings.showBtnCancel){
            this.$btnCancel = $('<button/>')
            .addClass(this.settings.btnCancelClass)
            .append(this.settings.btnCancelContent)
            .on('click',this.onCancel);
        }

        let $btnList = $('<ul/>')
        .addClass('list-inline');

        $btnList.append(
            $('<li/>')
            .addClass('list-inline-item')
            .append(this.$btnConfirm)
        );

        if(this.settings.showBtnCancel){
            $btnList.append(
                $('<li/>')
                .addClass('list-inline-item')
                .append(this.$btnCancel)
            );
        }

        $content
        .append(this.$message)
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .append($btnList)
        )
        
        this.$modal.on('keydown',function(event){
            var keycode = (event.keyCode ? event.keyCode : event.which);
            switch(keycode){
                case 13:
                    self.$btnConfirm.trigger('click');
                break;
                default:
                //do nothing
                break;
            }
        });

        return $content;
    }
    
    beforeConfirm() {
        this.settings.beforeConfirm(this);
    }

    onClose(event){
        this.onCancel(event);
        return super.onClose(event);
    }

    onConfirm(event){
        this.beforeConfirm();
        this.dispose();
        this.settings.onConfirm(event,this);
    }

    onCancel(event){
        this.dispose();
        this.settings.onCancel(event,this);
    }

}

module.exports = Confirm;